import React from "react";

const ForgetPassword: React.FC = () => {
  return <div className="forgetpw-form"></div>;
};

export default ForgetPassword;
